import api from '@/lib/api/axios'
import type { Manufacturer } from '@/types/entities'

export const manufacturersApi = {
    list: () => api.get<Manufacturer[]>('/api/manufacturers'),
    get: (id: number) => api.get<Manufacturer>(`/api/manufacturers/${id}`),
    create: (data: { name: string; icon?: number | null }) =>
        api.post<Manufacturer>('/api/manufacturers', data),
    update: (id: number, data: { name: string; icon?: number | null }) =>
        api.put<Manufacturer>(`/api/manufacturers/${id}`, data),
    delete: (id: number) => api.delete<{ id: number }>(`/api/manufacturers/${id}`),
}
